<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="1000px"
      scrollable
      @keydown="executeCloseModalSelectionFolderContainer"
      @click:outside="executeCloseModalSelectionFolderContainer"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5 v-if="currentFolder">
            Actualizar Carpeta Contenedora de: <b>{{ currentFolder.name }}</b>
          </h5>
          <h5 v-if="currentNameDocument">
            Actualizar Carpeta Contenedora de Documento:
            <b>{{ currentNameDocument.document_type.name }}</b>
          </h5>
          <h5 v-if="!currentNameDocument && !currentFolder">
            Agregar Carpeta Contenedora
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="my-5">
            <h5 class="font-weight-bold">Selecciona la Carpeta Contenedora</h5>
            <v-breadcrumbs
              class="p-0 py-3"
              :items="foldersBreadcrumb"
              v-if="foldersBreadcrumb.length"
            >
              <template v-slot:divider>
                <v-icon class="">mdi-play</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <h5
                  @click="updateFoldersToSelectFromBreadcrumb(item)"
                  :class="{
                    'font-weight-bold':
                      item.index == foldersBreadcrumb.length - 1,
                  }"
                  class="my-0 text-primary pointer"
                >
                  {{ item.text }}
                </h5>
              </template>
            </v-breadcrumbs>
            <v-row align-content="center" class="mt-3">
              <v-col
                @click="folderSelected = folder"
                @dblclick="
                  updateFoldersToSelect(folder);
                  folderSelected = null;
                "
                cols="12"
                md="3"
                sm="12"
                :class="{
                  'border-primary':
                    folderSelected && folderSelected.id == folder.id,
                  'border-gray':
                    !folderSelected || folderSelected.id != folder.id,
                }"
                class="py-3 px-1 mb-2 border mx-3 mt-5 rounded pointer border-hover border-2"
                v-for="folder in foldersToSelectAvailable"
                :key="folder.id"
              >
                <h5 class="my-1">
                  <v-icon class="mx-1"> mdi-folder </v-icon>
                  {{ folder.name }}
                </h5>
              </v-col>
              <h6
                v-if="foldersToSelectAvailable.length == 0"
                class="text-center mt-5"
              >
                <v-icon color="primary" x-large class="mx-2">
                  mdi-alert-circle-outline
                </v-icon>
                Sin Carpetas para mostrar
              </h6>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalSelectionFolderContainer"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            v-if="currentFolder"
            :disabled="currentFolderExistInRoot || loading"
            @click="updateFolderContainer(true)"
            color="primary text-white"
            class="float-right"
            :loading="loading"
            outlined
          >
            <small> Enviar a la Raiz </small>
          </v-btn>
          <v-btn
            :disabled="!folderSelected || loading"
            @click="updateFolderContainer(false)"
            :loading="loading"
            color="primary text-white"
            class="float-right"
          >
            <small> Seleccionar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";

export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalSelectionFolderContainer: {
      type: Function,
      default: () => {},
    },
    currentFolder: {
      default: null,
    },
    currentNameDocument: {
      default: null,
    },
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      folderSelected: null,
      foldersToSelect: [],
      foldersBreadcrumb: [
        {
          text: "Raiz",
          disabled: false,
          href: "#",
          root: true,
          index: 0,
          children: [],
        },
      ],
      foldersRoot: [],
    };
  },
  methods: {
    ...mapActions({
      updateOrCreateFolderDocument: "document/updateOrCreateFolderDocument",
      updateAssociatedNameDocument: "document/updateAssociatedNameDocument",
    }),
    executeCloseModalSelectionFolderContainer($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalSelectionFolderContainer($event);
      }
    },
    setFoldersToSelect(folders, foldersToSetRoot = false) {
      this.foldersToSelect = folders;
      if (foldersToSetRoot) {
        this.foldersRoot = folders;
      }
    },
    resetForm() {
      this.foldersBreadcrumb = [
        {
          text: "Raiz",
          disabled: false,
          href: "#",
          root: true,
          index: 0,
          children: [],
        },
      ];
      this.folderSelected = null;
    },
    async updateFolderContainer(toRoot = false) {
      if (!this.folderSelected && !toRoot) {
        this.$swal.fire({
          icon: "error",
          title: "Selecciona una carpeta contenedora",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          toast: true,
          position: "top-end",
        });
        return;
      }
      if (!this.currentFolder && !this.currentNameDocument) {
        this.$emit("folderSelected", this.folderSelected);
        this.resetForm();
        this.closeModalSelectionFolderContainer(true);
        return;
      }
      if (this.currentFolder) {
        const payload = {
          name: this.currentFolder.name,
          folder_id: this.currentFolder.id,
          updated_by: this.user.email,
          parent_id: toRoot ? null : this.folderSelected.id,
          project_id: this.isProject ? this.currentProject.id : undefined,
          pre_project_id: this.isPresale
            ? this.$route.query.presale_code
            : undefined,
        };
        const resp = await this.updateOrCreateFolderDocument(payload);
        if (resp.status == 200) {
          this.$swal.fire({
            icon: "success",
            title: "Excelente",
            text: `La carpeta contenedora ha sido actualizada correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("folderSelected");
          this.resetForm();
          this.closeModalSelectionFolderContainer(true);
        }
        if (!resp.status || resp.status === 400 || resp.status === 500) {
          return this.$swal.fire({
            icon: "error",
            title: "Error",
            text:
              resp.status == 500
                ? "Ha ocurrido un error de servidor, intenta nuevamente"
                : resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
      } else {
        let payload = {
          folder_document_type_id: this.currentNameDocument.id,
          required: this.currentNameDocument.required,
          pre_project_locked: this.currentNameDocument.pre_project_locked,
          updated_by: this.user.email,
          folder_id: this.folderSelected.id,
          document_type_id: this.currentNameDocument.document_type.id,
        };
        const resp = await this.updateAssociatedNameDocument(payload);
        if (resp.status == 200) {
          this.$swal.fire({
            icon: "success",
            title: "Excelente",
            text: `Carpeta Contenedora del Nombre de Documento actualizada correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("folderSelected");
          this.resetForm();
          this.closeModalSelectionFolderContainer(true);
        }
        if (!resp.status || resp.status === 400 || resp.status === 500) {
          this.loading = false;
          return this.$swal.fire({
            icon: "error",
            title: "Error",
            text:
              resp.status == 500
                ? "Ha ocurrido un error de servidor, intenta nuevamente"
                : resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
      }
    },
    updateFoldersToSelect(folder) {
      if (!this.foldersBreadcrumb.length) {
        this.foldersBreadcrumb.push({
          text: "Raiz",
          disabled: false,
          href: "#",
          root: true,
          index: 0,
          children: [],
        });
      }
      this.foldersBreadcrumb.push({
        text: folder.name,
        disabled: false,
        href: "#",
        root: false,
        index: this.foldersBreadcrumb.length,
        children: folder.children.filter((item) => item.status),
      });
      this.foldersToSelect = folder.children.filter((item) => item.status);
    },
    updateFoldersToSelectFromBreadcrumb(item) {
      this.foldersBreadcrumb = this.foldersBreadcrumb.slice(0, item.index + 1);
      let foldersToSet = item.root
        ? this.foldersRoot
        : item.children.filter((item) => item.status);
      this.setFoldersToSelect(foldersToSet, false);
      this.folderSelected = null;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({}),
  },
  watch: {
    currentFolder(newForm) {
      this.resetForm();
    },
    currentNameDocument(newForm) {
      this.resetForm();
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      currentProject: "project/currentProject",
    }),
    currentFolderExistInRoot() {
      return (
        this.currentFolder &&
        this.foldersRoot.find((item) => item.id == this.currentFolder.id) !=
          null
      );
    },
    foldersToSelectAvailable() {
      if (this.currentFolder) {
        return this.foldersToSelect.filter(
          (folder) => folder.id !== this.currentFolder.id
        );
      }
      return this.foldersToSelect;
    },
  },
};
</script>

<style>
.border-hover:hover {
  border: 2px solid rgb(85, 110, 230) !important;
}
.border-gray {
  border: 2px solid gainsboro !important;
}
</style>
